const key_user = 'bfa488a8-5c11-115e-a028-846d87930f15';
const key_jwt = 'bwar88a8-5ww1-1f5e-a0t8-846d87930f15';

export const StorageLineID = async (value) => {
  return await StorageProcess(key_user, value);
};

export const StorageTokenJWT = async (value) => {
  return await StorageProcess(key_jwt, value);
};

export const StorageProcess = async (store_key, value) => {
  if (value) {
    localStorage.setItem(store_key, value);
    return true;
  } else {
    let data = await localStorage.getItem(store_key);
    return data ? data : "";
  }
};

export const resetStorage = async () => {
  await localStorage.removeItem(key_user);
  await localStorage.removeItem(key_jwt);

  return true;
};